// Mock data for AI Chat tour demonstration
// Translation keys - actual text is in translations files

export const AI_CHAT_MOCK_QUESTION_KEY = "TOUR/AI_CHAT/MOCK_QUESTION" as const
export const AI_CHAT_MOCK_RESPONSE_KEY = "TOUR/AI_CHAT/MOCK_RESPONSE" as const

export const AI_CHAT_MOCK_SOURCES = [
  { title: "ISO 27001 Certificate", page: 1 },
  { title: "TÜV NORD ISO 9001", page: 1 },
  { title: "TÜV NORD ISO 14001", page: 1 },
]
